import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import React, { FC, ReactNode } from "react";
import { COLOR_GREY_8, COLOR_BLACK } from "../../theme/colors";
import { CloseIcon } from "../../theme/icons/CloseIcon";
import { StyledContent, StyledDrawer, StyledHead, StyledTitle } from "./styled";

type DrawerProps = {
  width?: number;
  isOpen: boolean;
  onCloseDrawer: () => void;
  anchor?: "left" | "top" | "right" | "bottom";
  title?: string | null;
  headingRight?: ReactNode;
  headingChip?: ReactNode;
  headingBottom?: ReactNode;
  children: ReactNode;
  Icon?: FC;
};

const Drawer: FC<DrawerProps> = ({
  onCloseDrawer,
  headingBottom,
  title,
  Icon = CloseIcon,
  headingChip,
  headingRight,
  children,
  width,
  isOpen,
  anchor,
}) => {
  const renderHeading = () => (
    <StyledHead isHeadingBottom={Boolean(headingBottom)}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <Box display="flex" alignItems="center">
          <IconButton onClick={onCloseDrawer}>
            <Icon color={COLOR_GREY_8} />
          </IconButton>
          {title && (
            <StyledTitle noWrap variant="heading4" color={COLOR_BLACK}>
              {title}
            </StyledTitle>
          )}
          <Box ml="1rem">{headingChip}</Box>
        </Box>
        {headingRight}
      </Box>
      {headingBottom}
    </StyledHead>
  );

  return (
    <StyledDrawer
      open={isOpen}
      onClose={onCloseDrawer}
      anchor={anchor ?? "right"}
      width={width}
    >
      {renderHeading()}
      <StyledContent headingBottom={headingBottom}>{children}</StyledContent>
    </StyledDrawer>
  );
};

export default Drawer;
